import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';


@Component({
  selector: 'neoris-dialog-yesno',
  templateUrl: './dialog-yesno.component.html',
  styleUrl: './dialog-yesno.component.css'
})
export class DialogYesnoComponent {
 
 
   public text: string = ""
   constructor(@Inject(MAT_DIALOG_DATA) public data: any,
   public dialogRef: MatDialogRef<DialogYesnoComponent>
   ) { 
 
     this.text = data.text;
   }


    
  


  back(){
    this.dialogRef.close(true)
  }

  close(){
    this.dialogRef.close(false)
  }

}
